import { DateInput, DateInputProps } from '@components/date-input'
import { FormField, FormFieldProps } from './field'

export type DateFieldProps = Omit<FormFieldProps<DateInputProps>, 'component'>

export function DateTextField(props: DateFieldProps) {
  return <FormField {...props} component={DateInput} />
}
